<script lang="ts" setup>
import { AuthProviderUtils } from '~/enums/auth-provider'
import type {AuthProvider} from '~/enums/auth-provider'

const messages = { failedToGetAuthUrl: 'Не удалось получить ссылку на авторизацию.' }

const { $apiHelper, $toast } = useNuxtApp()

const isGettingAuthUrl = ref({ tinkoffId: false, vkId: false, yandexId: false })

async function signIn (authProvider: AuthProvider): Promise<void> {
  isGettingAuthUrl.value[authProvider] = true

  try {
    const response = await $apiHelper.auth.getAuthUrl(authProvider) as any

    window.location.replace(response.meta.authUrl)
  } catch (error) {
    console.error(error)
    $toast.error(messages.failedToGetAuthUrl)
  }

  isGettingAuthUrl.value[authProvider] = false
}
</script>

<template>
  <div>
    <div class="flex justify-center space-x-3">
      <SvgIcon
        v-for="x in AuthProviderUtils.sortedMembers"
        :key="x"
        class="cursor-pointer text-[44px]"
        :class="{
          'pointer-events-none cursor-default opacity-50': isGettingAuthUrl[x]
        }"
        :name="AuthProviderUtils.getIconName(x)"
        @click="signIn(x)"
      />
    </div>
  </div>
</template>
